import { Component, OnInit, TemplateRef, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
//import { Router } from '@angular/router';
import { Validators, FormControl, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { PHBHPFeaturePackageUserManagementService } from '../ph-bhp-feature-package-user-management.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { UserData } from '../Models/UserData';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-adduser',
  templateUrl: './ph-bhp-adduser.component.html',
  styleUrls: ['./ph-bhp-adduser.component.css']
})

export class PhBhpAdduserComponent implements OnInit, OnDestroy, AfterViewInit {

  modalRef: BsModalRef;
  addUserFormGeneralInfo: UntypedFormGroup;
  institutionChecked = {} as any;
  submitted = false;
  searchText: string;
  institutionName;
  addUser: any = {};
  emitData: any = {
    key: "",
    val: ""
  }
  countryID = 0;
  emailExist: boolean = false;
  uNameExist: boolean = true;
  isMultiselect: boolean = true;
  Uservalue: any = {
    user: {},
    institutions: ""
  }
  institutionRadio;
  @ViewChild('cancelmodal') cancelmodal: TemplateRef<any>;
  //@Input() userRole: string = 'Institution User';
  userData: any;
  userSubscription: Subscription;
  userid: number;
  institutionId: string;
  isGroup: number;
  roleAndInstitutionsList: [any];
  institutionsList: any;
  selectins
  itemChange: boolean = false;
  user: UserData;
  admitedUserName: boolean = true;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  admitedChars = /^([A-Za-z0-9'.\-_!\^~]+)$/;

  constructor(
    private router: Router,
    public config: AppConfig,
    private activatedRoute: ActivatedRoute,
    private service: PHBHPFeaturePackageUserManagementService,
    public layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    public translate: TranslateService,
    private formbuilder: UntypedFormBuilder
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.userid = params.userid;
      this.institutionId = params.institutionId;
      this.isGroup = params.isGroup;
    });

    this.addUserFormGeneralInfo = this.formbuilder.group({
      name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required])],
      roleId: ['', Validators.compose([Validators.required])],
      isActive: [true],
      isEvaluationAccessible: [true],
      username: ['', Validators.compose([Validators.required, Validators.pattern(this.admitedChars)])],
      roleName: ['', Validators.compose([Validators.required])]
    });

    if (this.userid) {
      this.service.getUserByUserId(this.userid).subscribe((res: any) => {
        this.userData = this.config.userData;
        this.addUserFormGeneralInfo.setValue({
          name: res.user.name,
          email: res.user.email,
          roleId: res.user.roleId,
          isActive: res.user.isActive,
          isEvaluationAccessible: res.user.isEvaluationAccessible,
          username: res.user.username,
          roleName: ''
        });
        this.addUserFormGeneralInfo.get('email').disable();
        this.addUserFormGeneralInfo.get('username').disable();
        this.user = res.user;
        this.onUserChanges();
        var institutions = res.institutions.split(",");
        if(institutions) {
          institutions.forEach(x => this.institutionChecked[x] = true);
        }
      })
    } else {
      this.userData = this.config.userData;
      this.onUserChanges();
    }
    this.userSubscription = this.config.userSubject.asObservable().subscribe((changelang) => {
      this.userData = this.config.userData;
      this.onUserChanges();
    });



  }

  ngAfterViewInit() {
    const buttons = document.querySelectorAll('button');
    Array.from(buttons).forEach(el => el.setAttribute('name', 'button'));
  }

  onUserChanges() {
    if (this.userData && !this.itemChange) {
      this.itemChange = true;
      this.service.getUsersBountry(this.userData.userId).subscribe((res: any) => {
        this.roleAndInstitutionsList = res;
        const roleFinded = res.find(roleAndInstitutions => roleAndInstitutions.role.roleId == (this.user && this.user.roleId > 0 ? this.user.roleId : this.userData.roleName.roleId));
        if(this.addUserFormGeneralInfo && roleFinded && roleFinded.role && roleFinded.role.roleName) {
          this.addUserFormGeneralInfo.patchValue({ roleName: roleFinded.role.roleName });
        }

        if (this.userid) {
          this.onRoleChange(this.addUserFormGeneralInfo.value.roleId, false);
        }
        if (this.isGroup != null) {
          if (this.isGroup == 1) {
            this.institutionRadio = parseInt(this.institutionId);
          } else {
            this.institutionChecked[this.institutionId] = true
          }
          this.addUserFormGeneralInfo.get('roleId').disable()
          this.service.getInstitutionById(this.institutionId).subscribe((res) => {
            this.countryID = res[0].institution.countryID
            if (res[0].groupName != "") {
              this.institutionName = res[0].groupName + " / " + res[0].institution.institutionName
            } else {
              this.institutionName = res[0].institution.institutionName
            }
          })
        }
      })
    }
  }

  checkUserName(text) {

    if (!text) {
      this.admitedUserName = true;
      return;
    }

    if (text.match(this.admitedChars)) {
      this.admitedUserName = true;
    } else {
      this.admitedUserName = false;
    }
  }

  AvoidSpace(event) {
    var k = event ? event.which : event.keyCode;
    if (k == 32 || k == 64) return false;
  }

  ngOnDestroy() {
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
  }

  checkAll(ev) {
    this.countryID = 0;
    this.institutionsList.forEach((x, index) => {
      this.institutionChecked[x.institutionID] = ev.target.checked;
      if (index == 0 && ev.target.checked) {
        this.countryID = x.countryID;
      }
    })
  }

  submitUser(val) {
    if (this.addUserFormGeneralInfo.invalid) {
      //this.data.showError(this.data.translatetext('Add all Required Data'));
      this.submitted= true;
      return true;
    }
    if (!this.uNameExist) {
      this.submitted = true;
      return true;
    }
    if (this.isGroup != null) {
      this.addUserFormGeneralInfo.get('roleId').enable()
      val.roleId = this.addUserFormGeneralInfo.value.roleId
    }

    if (!this.userid) {
      this.saveUserData(val);

    } else {
      this.addUserFormGeneralInfo.get('email').enable()
      this.updateUser();
    }
  }

  institutionString() {
    if (this.isMultiselect) {
      return this.layoutService.objectString(this.institutionChecked);
    } else {
      return this.institutionRadio
    }
  }

  onRoleChange(index: number, doFalse = true) {
    var roleAndInstitutions;
        if(index === 0 ) {
          this.addUserFormGeneralInfo.patchValue({
            roleId: '',
            roleName: ""
          });
        }
    if (this.roleAndInstitutionsList) {
      roleAndInstitutions = this.roleAndInstitutionsList.find(roleAndInstitutions => roleAndInstitutions.role.roleId == index);
      if (roleAndInstitutions) {
        this.institutionsList = roleAndInstitutions.institutions;
        this.isMultiselect = roleAndInstitutions.isMultiselect;
        if(this.addUserFormGeneralInfo.get('roleId').value !== index) {
            this.addUserFormGeneralInfo.patchValue({
              roleId: index,
              roleName: roleAndInstitutions.role.roleName
            });
        }
      }
    }
    if (doFalse) {
      for (var key in this.institutionChecked) {
        this.institutionChecked[key] = false;
      }
    } if (!this.isMultiselect) {
      for (var key in this.institutionChecked) {
        this.institutionRadio = parseInt(key);
      }
    }


  }
  checkValue(institution, ev) {
    if (institution.availedUserLicense <= 0 && ev.target.checked) {
      this.layoutService.showError(this.layoutService.translateText('USER_MANAGEMENT.USER_LICENSE_NOT_AVAILABLE'));
      ev.target.checked = false;
      this.institutionChecked[institution.institutionID] = false;
      ev.stopPropagation();
      return;
    }

    if (ev.target.checked == false) {
      this.selectins = ev.target.checked;
    }

    this.countryID = institution.countryID;
    institution.availedUserLicense = ev.target.checked ? institution.availedUserLicense - 1 : institution.availedUserLicense + 1;
  }

  checkValueradio(institution) {
    this.countryID = institution.countryID
  }

  userNameExist() {
    var username = this.addUserFormGeneralInfo.value.username;
    if (username != "") {
      // this.service.getUsernameExist(username).subscribe((res:any)=>{
      //   this.uNameExist = res;
      // })
    }
  }

  userEmailExist() {
    var email = this.addUserFormGeneralInfo.value.email;
    if (email != "") {
      // this.service.getUserEmailExist(email).subscribe((res:any)=>{
      //   this.emailExist = res;
      // })
    }
  }

  randomPassword(length) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var newpassword = "";
    for (var x = 0; x < length; x++) {
      var i = Math.floor(Math.random() * chars.length);
      newpassword += chars.charAt(i);
    }
    return newpassword;

  }

  saveUserData(val) {
    this.Uservalue.user = {
      "name": val.name,
      "lastName": "",
      "username": val.username,
      "email": val.email,
      "password": "",
      "roleId": val.roleId,
      "isActive": val.isActive,
      "isEvaluationAccessible": val.isEvaluationAccessible,
      "countryId": this.countryID,
      "createdBy": this.userData.userId
    };

    this.Uservalue.webUrl = this.config.siteUrl;
    this.Uservalue.languageCode = localStorage.getItem("selectedlanguage");
    this.Uservalue.user.username = this.Uservalue.user.username.split(' ').join('');
    if (this.institutionId) this.Uservalue.institutions = this.institutionId;
    else this.Uservalue.institutions = this.institutionString();
    this.layoutService.showLoader = true;
    var data = {
      personalInformation: this.Uservalue,
      platformUserPersonalInformation: null
    }
    this.service.registerUser(data).subscribe((res: any) => {
      // this.layoutService.showSuccess(this.layoutService.translateText('USER_MANAGEMENT.SUCCESSFULLY_ADDED_USER'));
      this.layoutService.showLoader = false;
      //localStorage.setItem("token",res.token);
      this.emitData = {};
      this.emitData.key = "user";
      this.emitData.val = res;
      this.onChildData(this.emitData);
    });
  }

  updateUser() {
    this.Uservalue.user = this.addUserFormGeneralInfo.value;
    this.Uservalue.user.userId = this.userid
    this.Uservalue.user.updatedBy = this.userData.userId;
    this.Uservalue.user.countryId = (this.countryID) ? this.countryID : this.user.countryId;

    this.Uservalue.institutions = this.institutionString();
    if (this.Uservalue.user.username) {
      this.Uservalue.user.username = this.Uservalue.user.username.split(' ').join('');
    }

    //value.updatedBy =this.userData.userId;
    this.layoutService.showLoader = true;
    this.service.updateUserById(this.Uservalue, this.userid).subscribe((res: any) => {
      // this.layoutService.showSuccess(this.layoutService.translateText('USER_MANAGEMENT.SUCCESSFULLY_UPDATED_USER'));
      this.layoutService.showLoader = false;
      this.emitData = {};
      this.emitData.key = "user";
      //this.emitData.val = res;
      this.onChildData(this.emitData);
    });
  }

  cancelModal() {
    if (this.addUserFormGeneralInfo.dirty) {
      this.openCancelModal(this.cancelmodal)
    }
    else {
      this.CancelUser()
    }
  }

  openCancelModal(cancelmodal: TemplateRef<any>) {
    this.modalRef = this.modalService.show(cancelmodal, Object.assign({}, { class: 'w-420' })
    )
  }


  CancelUser() {
    this.emitData = {};
    this.emitData.key = "user";
    //this.emitData.val=res.user;
    this.onChildData(this.emitData);
  }

  backToManageUser() {
    this.emitData = {};
    if (this.institutionId) {
      this.emitData.key = "institution";
    } else {
      this.emitData.key = "user";
    }

    //this.emitData.val=res.user;
    this.onChildData(this.emitData);
  }

  onChildData(event: any) {
    this.router.navigate([event.key]);
  }

  isRoleValid() {
    return this.addUserFormGeneralInfo.get('roleId').valid || !this.submitted;
  }

  filterRoleOptions() {
    if (!this.roleAndInstitutionsList) return;
    var roleAndInstitutionsSubList;
    //User is asigning a new user
    if (this.isGroup != null && this.isGroup == 1) {
      roleAndInstitutionsSubList = this.roleAndInstitutionsList.filter(roleAndInstitutions => roleAndInstitutions.role.roleId == 3);
    }
    else if (this.isGroup != null && this.isGroup == 0) {
      roleAndInstitutionsSubList = this.roleAndInstitutionsList.filter(roleAndInstitutions => roleAndInstitutions.role.roleId > 3);
    }
    //User is creating a new user
    else roleAndInstitutionsSubList = this.roleAndInstitutionsList;
    return roleAndInstitutionsSubList;
  }
}
